export default [
    // *--------- PILLAR ---------------------------------*
    {
        path: '/railway-structure/pillar/list',
        name: 'railway_structure-pillar-list',
        component: () => import('@/views/apps/railway_structure/pillar/views/List.vue'),
        meta: {
            resource: 'pillar',
            action: 'read',
            pageTitle: 'Опоры',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Опоры',
                  active: true,
                },

            ],
        },
    },
    {
        path: '/railway-structure/pillar/view/:id',
        name: 'railway_structure-pillar-view',
        component: () => import('@/views/apps/railway_structure/pillar/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Опоры',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Опоры',
                    to: {
                        name: 'railway_structure-pillar-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
